export default class Env {

    /**
     * @param {Object} config 
     */
    static set(config){
        this.config = config;
    }

    /**
     * @param {string} key 
     * @returns {*}
     */
    static get(key){
        return this.config[key];
    }
}